<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-dark">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">イベント詳細情報</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div v-if="!EventInfo">
          <base-alert type="warning">
            <span class="alert-inner--icon"><i class="fa fa-question"></i></span>
            <span class="alert-inner--text"><strong>イベント情報無し</strong> イベント情報が見つかりませんでした。URLをお確かめいただくか、再読み込みして下さい。</span>
          </base-alert>
        </div>
        <div v-else>
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ EventInfo.Name }}</h2>
              <h4 v-show="EventInfo.IsPetit == true">（内オンリーイベント「{{ EventInfo.PetitName }}」）</h4>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h5>
                  開催日：{{ EventInfo.StartDate }}
                  <span v-show="EventInfo.MultipleDaysEvent == true">～{{ EventInfo.EndDate }}</span>
                </h5>
                <h5>場所：{{ EventInfo.Prefecture }}・{{ EventInfo.Place }}</h5>
                <h6 v-show="EventInfo.Hole">　　　{{ EventInfo.Hole }}</h6>
                <h5>状態：{{ EventInfo.EventStatus }}</h5>
                <div v-if="EventInfo.EventStatus == '参加' || EventInfo.EventStatus == '終了'">
                  <h5>配置：{{ EventInfo.Position }}</h5>
                </div>
                <p v-html="EventInfo.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src="EventInfo.CircleCutUrl" class="img-fluid shadow">
            </div>
          </div>
          <hr>
          <div v-if="EventInfo.MenuUrls">
            <div class="row text-center justify-content-center">
              <div class="col-lg-10">
                <h3 class="display-3">お品書き</h3>
              </div>
            </div>
            <div class="row row-grid align-items-center">
              <div v-for="(item, index) in EventInfo.MenuThumbnailUrls" :key="item.id" class="col-md-4">
                <img :src="item" class="img-fluid shadow" @click="opemImageModal(EventInfo.MenuUrls[index])" style="cursor:pointer">
              </div>
            </div>
            <div>
              <b-modal ref="image-modal" id="image-modal" centered size="lg" :hide-footer="true" header-class="p-2 border-bottom-0">
                <img :src="ModalImageUrl" class="img-fluid shadow">
              </b-modal>
            </div>
            <hr>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-12">
              <div class="btn-wrapper">
                <div v-if="EventInfo.Url">
                  <a :href="EventInfo.Url" target="_blank">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="primary"
                                 icon="ni ni-building">
                      イベントHP
                    </base-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "eventDetail",
  components: {
    moment
  },
  data() {
    return{
      Book: {},
      Events: [],
      EventInfo: {},
      ModalImageUrl: "",
      HeadParam: {
        title: 'イベント詳細情報',
        description: '',
        image: location.origin + '/img/brand/default.png',
        card_type: 'summary_large_image'
      }
    };
  },
  head: {
    title: function () {
      return{
        inner: '雛菊書房',
        separator: ' - ',
        complement: this.HeadParam.title
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - ' + this.HeadParam.title },
        { property: 'og:type', content: 'article' },
        { property: 'og:description', content: this.HeadParam.description },
        { property: 'og:image', content: this.HeadParam.image },
        { property: 'twitter:card', content: this.HeadParam.card_type },
      ]
    }
  },
  created() {
    moment.locale('ja')
    this.getEventInfo(this.$route.params.id)
  },
  updated () {
    this.$emit('updateHead');
  },
  methods: {
    opemImageModal(ImageUrl){
      this.ModalImageUrl = ImageUrl
      this.$refs['image-modal'].show()
    },
    getEventInfo(EventId) {
      this.axios.get('/strapi/api/event-informations/' + EventId + '?populate=%2A&pagination[pageSize]=50')
          .then(response =>{
            if(response.data.data) {
              this.EventInfo = response.data.data.attributes
              this.EventInfo['StartDate'] = moment(this.EventInfo['StartDate']).format('YYYY/MM/DD(ddd)')
              this.EventInfo['EndDate'] = moment(this.EventInfo['EndDate']).format('YYYY/MM/DD(ddd)')
              if (this.EventInfo['StartDate'] != this.EventInfo['EndDate']) {
                this.EventInfo['MultipleDaysEvent'] = true
              } else {
                this.EventInfo['MultipleDaysEvent'] = false
              }
              switch (this.EventInfo['EventStatus']){
                case "Announced":
                  this.EventInfo['EventStatus'] = "開催告知あり";
                  break;
                case "Planning":
                  this.EventInfo['EventStatus'] = "参加予定";
                  break;
                case "Submitted":
                  this.EventInfo['EventStatus'] = "申込済み";
                  break;
                case "Listed":
                  this.EventInfo['EventStatus'] = "配置発表待ち（当選済）";
                  break;
                case "Placed":
                  this.EventInfo['EventStatus'] = "参加";
                  break;
                case "Finished":
                  this.EventInfo['EventStatus'] = "終了";
                  break;
                case "Suspended":
                  this.EventInfo['EventStatus'] = "中止/延期";
                  break;
                case "Postponed":
                  this.EventInfo['EventStatus'] = "延期（延期先発表済）";
                  break;
                case "Cancelled":
                  this.EventInfo['EventStatus'] = "中止";
                  break;
                case "Declined":
                  this.EventInfo['EventStatus'] = "欠席/配置辞退";
                  break;
                default:
                  break;
              }
              if (this.EventInfo['Description']){
                this.EventInfo['Description'] = this.EventInfo['Description'].replace(/\r?\n/g, '<br >');
              }
              if (response.data.data.attributes.CircleCut.data){
                this.EventInfo['CircleCutUrl'] = '/strapi' + response.data.data.attributes.CircleCut.data.attributes.url
                this.HeadParam.title =  response.data.data.attributes.Name
                this.HeadParam.description = response.data.data.attributes.Name + ' に関する雛菊書房の参加情報'
                this.HeadParam.image = location.origin + '/strapi' + response.data.data.attributes.CircleCut.data.attributes.formats.thumbnail.url
              } else {
                this.HeadParam.title =  response.data.data.attributes.Name
                this.HeadParam.description = response.data.data.attributes.Name + ' に関する雛菊書房の参加情報'
                this.HeadParam.card_type = 'summary'
              }
              if (this.EventInfo.Menu.data){
                this.EventInfo['MenuUrls'] = []
                this.EventInfo['MenuThumbnailUrls'] = []
                this.EventInfo.Menu.data.forEach(function (value){
                  this.EventInfo['MenuThumbnailUrls'].push('/strapi' + value.attributes.formats.medium.url)
                  this.EventInfo['MenuUrls'].push('/strapi' + value.attributes.url)
                }, this)
              }
            } else {
              this.EventInfo = null
              this.HeadParam.card_type = 'summary'
            }
          }).catch(error =>{
        console.log(error)
      })
    },
  }
};
</script>
<style>
</style>
